import { render, staticRenderFns } from "./StudBookSearchField.vue?vue&type=template&id=796a197a&scoped=true"
import script from "./StudBookSearchField.vue?vue&type=script&lang=ts"
export * from "./StudBookSearchField.vue?vue&type=script&lang=ts"
import style0 from "./StudBookSearchField.vue?vue&type=style&index=0&id=796a197a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a197a",
  null
  
)

export default component.exports